/* eslint-disable no-redeclare */

import { z } from 'zod';

import { Device } from '../primitive/device';

export const UserTracking = z
  .object({
    utmSource: z.string(),
    utmCampaign: z.string(),
    utmMedium: z.string(),
    utmContent: z.string(),
    utmTerm: z.string(),
    aid: z.string(),
    pubid: z.string(),
    subid: z.string(),
    gclid: z.string(),
    msclkid: z.string(),
    irpid: z.string(),
    ircid: z.string(),
    btSid: z.string(),
    source: z.string(),
    creativeId: z.string(),
    partnerSubId: z.string(),
    device: Device,
    pcid: z.string(),
    prPid: z.string(),
  })
  .partial();

export type UserTracking = z.infer<typeof UserTracking>;
